module.exports = __webpack_public_path__ + "static/media/check.b3a0c38a.svg";